import {Component, Inject, OnInit, Input, Output, EventEmitter} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {IPostMessageEventTarget, PostMessageBridgeFactory} from "@tekool/ngx-post-message-angular-9";
import {environment} from "../../../environments/environment";
import {FormDeterminant} from "../../models/form-determinant";
import {LogicGroup} from "../../models/jsonlogic/logic-group";

import {FormDeterminantControllerService} from "../../services/form-controller/form-determinant-controller.service";
import {LanguageControllerService} from "../../services/language-controller/language-controller.service";
import {Store} from "../../services/store.service";
import {IPostMessageBridge} from "@tekool/ngx-post-message-angular-9/src/IPostMessageBridge";
import {DeterminantControllerService} from "../../services/registration-controller/determinant-controller.service";

/**
 * This determinant window is used in formiojs using iframe.
 */
@Component({
  selector: "generic-determinant-builder",
  templateUrl: "./general-determinant-builder.component.html",
  providers: [FormDeterminantControllerService],
})
export class GeneralDeterminantBuilderComponent implements OnInit {

  @Input() public serviceId: string;
  @Input() public componentKey: string;
  @Input() public propKey: string;
  @Input() public direct: boolean = false;
  @Input() public determinantMapById: { [key: string]: string } = {};
  @Output() public changeDeterminants: EventEmitter<any> = new EventEmitter();
  public formDeterminant: FormDeterminant = new FormDeterminant();
  private messageBridge: IPostMessageBridge;
  private tabComponentData?: any;
  public showDrawerHeader: boolean = true;
  public showEditDrawer: boolean = false;

  constructor(private route: ActivatedRoute, public store: Store, public translate: TranslateService,
              private formDeterminantControllerService: FormDeterminantControllerService,
              private determinantService: DeterminantControllerService,
              private languageService: LanguageControllerService,
              @Inject(PostMessageBridgeFactory) private bridgeFactory: PostMessageBridgeFactory) {

    const parentWindow: IPostMessageEventTarget = window.top;
    const iFrame: IPostMessageEventTarget = window;
    translate.setDefaultLang(store.state.common.lang);
    languageService.getLanguages().subscribe(
      (data) => {
        translate.addLangs(data.map((l) => l.code));
      });

    this.messageBridge = bridgeFactory.makeInstance()
      .setEnableLogging(false)
      .connect(iFrame, parentWindow)
      .makeBridge("FormBuilder")
      .addListener("FormBuilder", (messageString: any) => {
        const data = JSON.parse(messageString);
        if (data.event === "receivedCurrentComponent" && data.serviceId === this.serviceId && data.data && data.data.key === this.componentKey) {
          this.tabComponentData = data.data;
          this.loadFieldDeterminant();
        }
      });
  }

  public ngOnInit() {
    if (!this.serviceId && !this.componentKey) {
      this.route.params.subscribe((params) => {
        this.serviceId = params.serviceId;
        this.store.state.common.serviceId = params.serviceId;
        this.getServiceDeterminantKeyName();
      });
      this.route.queryParamMap.subscribe((queryParams) => {
        this.componentKey = queryParams.get("key");
        this.propKey = queryParams.get("propKey");
      });
    }
    window.top.postMessage([{
      channel: "FormBuilder",
      message: JSON.stringify({event: "receiveCurrentComponent"}),
    }], "*");
  }

  public openEditor() {
    this.showEditDrawer = true;
    console.log("open editor");
  }

  public getServiceDeterminantKeyName() {
    this.determinantService.getServiceDeterminantIdAndName(this.serviceId).subscribe(
      (data) => Object.assign(this.determinantMapById, data),
    );
  }

  public showModalHeader(e) {
    console.log(e);
    this.showDrawerHeader = e;
  }

  public closeEdit() {
    // @ts-ignore
    this.showEditDrawer = !this.showEditDrawer;
    this.loadFieldDeterminant();
    this.sendMessage();
    this.store.state.common.determinantSection.topLayer = "list";
    this.store.state.common.determinantSection.determinant = {};
    this.backFromEdit();
  }

  public backFromEdit() {
    const windowParent = window.parent.document.querySelector(".component-settings").querySelector(".formio-dialog-content > div > div");
    if (windowParent) {
      // const windowParent = window.parent.document.querySelector(".component-settings").querySelector(".formio-dialog-content > div > div");
      windowParent.classList.remove("p-0", "m-0");
      windowParent.querySelectorAll(".page-iframe")?.forEach((iframe) => iframe.classList.remove("full-drawer-content"));
      windowParent.querySelector(":scope > .row:nth-child(1)").classList.remove("d-none");
      windowParent.querySelector(":scope > .row:nth-child(2)").classList.remove("p-0");
      windowParent.querySelector(":scope > .row:nth-child(2)").querySelector("#myBuilder").classList.remove("m-0");
      windowParent.querySelector(":scope > .row:nth-child(2)").querySelector(".tab-pane.active").classList.remove("p-0", "m-0");
      windowParent.querySelector("#element1").querySelector(":scope > .formio-component-tabs").querySelector(":scope > div > .nav-tabs").classList.remove("d-none");
      window.parent?.document?.querySelector(".component-settings").querySelector(".formio-dialog-close").classList.remove("d-none");

      const copyValueFrom = windowParent.querySelector(":scope > .row:nth-child(2)").querySelector("#copyValueFromTab").querySelector(":first-child");
      if (copyValueFrom) {
        copyValueFrom.classList.remove("d-none");
      }
      // windowParent.querySelector(":scope > .row:last-child").classList.add("d-none");
    }
  }

  private checkRemovedDeterminant(determinants: any[], deletedDeterminantId: string) {
    if (!Array.isArray(determinants)) {
      return;
    }
    const deletedDets = [];
    for (const determinant of determinants) {
      if (determinant.id === deletedDeterminantId || determinant.determinantId === deletedDeterminantId) {
        deletedDets.push(determinant);
      } else {
        this.checkRemovedDeterminant(determinant.items, deletedDeterminantId);
      }
    }
    for (const determinant of deletedDets) {
      const index = deletedDets.indexOf(determinant);
      determinants.splice(index, 1);
    }
  }

  private loadFieldDeterminant() {
    if (this.tabComponentData && this.tabComponentData[this.propKey]) {
      this.formDeterminant.jsonDeterminant = JSON.parse(JSON.stringify(this.tabComponentData[this.propKey]));
    }
  }

  public saveDeterminant(json: any) {
    this.formDeterminant.jsonDeterminant = json;
    this.tabComponentData[this.propKey] = this.formDeterminant.jsonDeterminant;
    this.formDeterminant.key = this.componentKey;
    this.sendMessage();
    // emit chanve
    this.changeDeterminants.emit(this.formDeterminant.jsonDeterminant);
  }

  private sendMessage(): void {
    const message = {key: this.componentKey};
    message[this.propKey] = this.formDeterminant.jsonDeterminant;
    const messageString: string = JSON.stringify(message);
    window.top.postMessage([{channel: "FormBuilder", message: messageString}], "*");
  }

}
